// extracted by css-extract-rspack-plugin
export default {"list":"ForYouSubSection-module__list__suKwZ"};